"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponsiveSSRPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const media_constants_1 = require("../../media-query/media-constants");
const MediaQueryContext_1 = require("../../media-query/MediaQueryContext");
/**
 * Component that makes a page responsive for SSR purposes
 * Make sure that the component is at the top of the page.
 *
 * Make sure any call to useDesktopMediaQuery, useMobileMediaQuery or useTabletMediaQuery hook are made in a component that is inside the tree wrapped by this component
 */
function ResponsiveSSRPage({ isMobileServerSide = true, children, }) {
    const [mounted, setMounted] = (0, react_1.useState)(false);
    const widthOverride = (0, react_1.useMemo)(() => {
        if (mounted) {
            // no override when on client side
            return undefined;
        }
        return isMobileServerSide ? media_constants_1.MOBILE_MAX_WIDTH : media_constants_1.TABLET_MAX_WIDTH;
    }, [isMobileServerSide, mounted]);
    (0, react_1.useEffect)(() => {
        setMounted(true);
    }, []);
    return (0, jsx_runtime_1.jsx)(MediaQueryContext_1.MediaQueryProvider, { widthOverride: widthOverride, children: children });
}
exports.ResponsiveSSRPage = ResponsiveSSRPage;
//# sourceMappingURL=index.js.map